import { Link } from "react-router-dom";
import styles from "./InsightsStrip.module.css";

const InsightsStrip = ({ items = [], arrowImage }) => {
const getColClass = () => {
  if (items.length <= 2) return `col-12 col-md-${12 / items.length}`;
  return "col-12 col-md-4";
};

const colClass = getColClass();

  return (
    <section className={`container-fluid ${styles.wrapper}`}>
      <div className="row g-0">
        {items.map((item, index) => (
          <div key={index} className={`${colClass} ${styles.card}`}>
            <h3 className={styles.title}>{item.title}</h3>

            {item.subtitle && (
              <p className={styles.subtitle}>{item.subtitle}</p>
            )}

            {/* Arrow Link Navigation */}
            <Link to={item.link} className={styles.arrow}>
              <img src={arrowImage} alt="Navigate" />
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default InsightsStrip;
